import { render, staticRenderFns } from "./ProjectBillingPieChart.vue?vue&type=template&id=cfb97194"
import script from "./ProjectBillingPieChart.vue?vue&type=script&lang=ts"
export * from "./ProjectBillingPieChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports